// src/redux/slices/generatingSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isGenerating: false,
  generatingText: '',        // Default text
  isLayoutGenerating: false, // NEW: track dashboard-layout generation
};

const generatingSlice = createSlice({
  name: 'generating',
  initialState,
  reducers: {
    setGenerating: (state, action) => {
      state.isGenerating = action.payload;
      // If not generating, reset text to default
      if (!action.payload) {
        state.generatingText = '';
      }
    },
    setGeneratingText: (state, action) => {
      state.generatingText = action.payload;
    },
    setLayoutGenerating: (state, action) => {           // NEW: toggle layout generation
      state.isLayoutGenerating = !!action.payload;      // always boolean
    },
  },
});

export const {
  setGenerating,
  setGeneratingText,
  setLayoutGenerating, // NEW: export the action
} = generatingSlice.actions;

export default generatingSlice.reducer;